import type { FC } from "react";
import { routes } from "../../../routes";
import { AlertMessageConditions, type AlertMessageContext } from "../types";
import { AlertMessageLink } from "../../../../components/AlertMessage/AlertMessageLink";
import type { AlertMessageLinkWrapperProps } from "./types";

export const DefaultNoSavedPharmaciesLink: FC<
  AlertMessageLinkWrapperProps & {
    alertMessageContext: AlertMessageContext;
  }
> = ({ children, alertMessageContext, ...props }) => {
  return (
    <AlertMessageLink
      {...props}
      to={{
        pathname: routes.inNetworkPharmacy.replace(
          ":id",
          alertMessageContext?.planId || ""
        ),
        state: alertMessageContext?.routerState,
        search: alertMessageContext?.search,
      }}
      condition={AlertMessageConditions.NO_SAVED_PHARMACIES}
    >
      {children}
    </AlertMessageLink>
  );
};

export const NoSavedPharmaciesLink: FC<
  AlertMessageLinkWrapperProps & {
    alertMessageContext: AlertMessageContext;
  }
> = ({ children, alertMessageContext, ...props }) => {
  const hasPlan = !!alertMessageContext.planId;
  const inNetworkPharmacyFinderLink = routes.inNetworkPharmacy.replace(
    ":id",
    alertMessageContext?.planId || ""
  );
  const summaryPageAddPharmaciesLink = hasPlan
    ? inNetworkPharmacyFinderLink
    : routes.pharmacy;
  return (
    <AlertMessageLink
      {...props}
      to={{
        pathname: alertMessageContext.isFromSummaryPage
          ? summaryPageAddPharmaciesLink
          : inNetworkPharmacyFinderLink,
        search: alertMessageContext?.search,
        state: alertMessageContext?.routerState,
      }}
      condition={AlertMessageConditions.NO_SAVED_PHARMACIES}
    >
      {children}
    </AlertMessageLink>
  );
};
